<template>
  <el-dialog
      :title="setId?'编辑班级':'新增班级'"
      :visible.sync="dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="classForm" :rules="rules" ref="classForm" label-width="100px">
      <el-form-item label="入学年份" prop="year">
        <el-input type="number" v-model.number="classForm.year" placeholder="请输入入学年份"></el-input>
      </el-form-item>
      <el-form-item label="班级名称" prop="class_name">
        <el-input v-model="classForm.class_name" placeholder="请输入班级名称"></el-input>
      </el-form-item>
      <el-form-item label="班级教务" prop="per_id">
        <el-select v-model="classForm.per_id" placeholder="请选择班级教务" style="width: 100%">
          <el-option v-for="item in perList" :key="item.per_id" :label="item.admin_name" :value="item.aid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班级学制" prop="class_type">
        <el-select v-model="classForm.class_type" placeholder="请选择班级学制" style="width: 100%">
          <el-option label="3年制大专" value="1"></el-option>
          <el-option label="4年制本科" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开学时间" prop="open_date">
        <el-date-picker
            style="width: 100%"
            v-model="classForm.open_date"
            :picker-options="pickerOptions"
            type="date"
            placeholder="请选择开学时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="毕业时间" prop="graduate_date">
        <el-date-picker
            style="width: 100%"
            v-model="classForm.graduate_date"
            :picker-options="pickerOptions"
            type="date"
            placeholder="请选择毕业时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('classForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('classForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {classAdd, instructor} from "@/api/fuse";

export default {
  name: "classDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      perList: [],
      classForm: {
        year: '',
        class_name: '',
        per_id: '',
        class_type: '',
        open_date: null,
        graduate_date: null,
      },
      rules: {
        year: [
          {required: true, message: '请输入入学年份', trigger: 'blur'},
        ],
        class_name: [
          {required: true, message: '请输入班级名称', trigger: 'blur'},
        ],
        per_id: [
          {required: true, message: '请选择班级教务', trigger: 'change'},
        ],
        class_type: [
          {required: true, message: '请选择班级学制', trigger: 'change'},
        ],
        open_date: [
          {type: 'date', required: true, message: '请选择开学时间', trigger: 'change'},
        ],
        graduate_date: [
          {type: 'date', required: true, message: '请选择毕业时间', trigger: 'change'},
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          console.log(time)
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      let _data = await instructor()
      this.perList = _data.data
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await classAdd(
          this.classForm.year,
          this.classForm.class_name,
          this.classForm.per_id,
          this.classForm.class_type,
          this.$tools.ZHDate(new Date(this.classForm.open_date), 1),
          this.$tools.ZHDate(new Date(this.classForm.graduate_date), 1),
          this.setId ? this.setId : ''
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    setItem() {
      this.classForm = {
        year: this.setItem.year,
        class_name: this.setItem.class_name,
        per_id: this.setItem.per_id,
        class_type: this.setItem.class_type ? this.setItem.class_type.toString() : '',
        open_date: this.setItem.open_date ? new Date(this.setItem.open_date) : null,
        graduate_date: this.setItem.graduate_date ? new Date(this.setItem.graduate_date) : null,
      };
      this.$nextTick(()=>{
        this.$refs['classForm'].clearValidate()
      })
    },

  }
}
</script>

<style scoped lang="scss">

</style>